import React from 'react';


const tecno = [

    { T: 'Qlik Sense', L: 'https://www.qlik.com/es-es/products/qlik-sense' },
    { T: 'Pentaho', L: 'https://www.hitachivantara.com/en-us/products/data-management-analytics/pentaho.html' },
    { T: 'Oracle', L: 'https://www.oracle.com/index.html' },

];

class Biapp extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="content">





                    <div className="sectionProyect">


                        <div className="titleSectionProyect">
                            <h1>Business Intelligence</h1>

                        </div>
                        <svg> <rect></rect> </svg>

                        <iframe src="https://www.youtube.com/embed/R9BPb-BGPNQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        <div className="listT" >

                            {tecno.map(tec => (
                                <div key={tec}>
                                    <a href={tec.L} target="_blank" rel="noreferrer">

                                        <button className="animateButtonTech">  <p> <span>&#183;</span> {tec.T}</p></button>
                                    </a>
                                </div>

                            ))}
                        </div>

                        <p>This BI project combines data from the OE and Northwind databases, creating a star model applying ETL processes with Pentaho and BI graphs with Qlik Sense Desktop.</p>
                        <a href="https://github.com/BrandonGrimaldoM/BIQlikSense" target="_blank" rel="noreferrer">
                            <button className="animateButtonGit"> <p>Repository </p> <div className="gitIcon"></div> </button>
                        </a>
                    </div>




                </div>


            </React.Fragment>
        );
    }
}

export default Biapp;